import React, { Component, Fragment } from 'react';
import intl from 'react-intl-universal';
import Grid from '@material-ui/core/Grid';
import TextInput from 'src/ui/library/TextInput';
import Button from 'src/ui/library/Button';
import LoginError from './forms/LoginErrorPres';

export const validatePassword = (password, reTypePassword) => {
  let errors = [];
  if (password !== reTypePassword) errors.push('Passwords are not equals');
  if (password.length < 8) errors.push('Password is two short');

  return {
    error: errors.length > 0,
    errors,
  };
};

class ResetPassword extends Component {
  state = {
    password: '',
    reTypePassword: '',
    errorPassword: false,
  };

  onClick = evt => {
    evt.preventDefault();
    const { password, reTypePassword } = this.state;
    const validPassword = validatePassword(password, reTypePassword);
    this.setState({
      errorPassword: validPassword.errors,
    });
    if (!validPassword.error) return this.props.onClick(password);
  };

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value,
    });
  };

  render() {
    const { error, numberAttempts, isUserLocked, resetPasswordStatus } = this.props;
    const ref = isUserLocked || resetPasswordStatus === 'PENDING';
    return (
      <Fragment>
        <Grid item xs={12} lg={12}>
          <div className="title">{intl.get('login.resetPassword.title')}</div>
        </Grid>
        <LoginError isUserLocked={isUserLocked} numberAttempts={numberAttempts} error={error} maxAttempts={'third attempt'} />
        <Grid item xs={12}>
          <TextInput
            autoComplete={'off'}
            id="password"
            name="password"
            label={intl.get('login.resetPassword.passwordInput')}
            type="password"
            styleType={'login'}
            hasError={this.state.errorPassword.length || (error && error.message !== '')}
            onChange={this.handleChange}
            tabIndex={1}
            helperText={this.state.errorPassword.length ? intl.get('login.alert.noData.password.helperText') : ''}
          />
        </Grid>
        <Grid item xs={12}>
          <TextInput
            autoComplete={'off'}
            id="reTypePassword"
            name="reTypePassword"
            label={intl.get('login.resetPassword.reTypePassword')}
            type="password"
            styleType={'login'}
            hasError={this.state.errorPassword.length || (error && error.message !== '')}
            onChange={this.handleChange}
            tabIndex={2}
            helperText={this.state.errorPassword.length ? intl.get('login.alert.noData.password.helperText') : ''}
          />
        </Grid>
        <Grid item xs={12} lg={3}>
          <Button onClick={this.onClick} tabIndex={3} styleType={'login'} disabled={ref}>
            <span>{intl.get('login.submit')}</span>
          </Button>
        </Grid>
      </Fragment>
    );
  }
}

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/ui/features/Login/presentational/ResetPasswordPres.js